import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setForm({
        name: '',
        email: '',
        message: ''
      });
    }, 5000);
  };
  return <div className="w-full bg-sand min-h-screen pt-24" data-id="element-496" data-mp="12z0eu9fvlkqr">
      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-497" data-mp="fa7ocsi0w53j">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-498" data-mp="f8mwxbr0929w">
          {/* Info Side */}
          <motion.div {...fadeIn} data-id="element-499" data-mp="aaldgppo30xw">
            <h1 className="text-4xl md:text-5xl font-serif text-navy mb-6" data-id="element-500" data-mp="a9a7cj8r1h3m">
              Let's Connect
            </h1>

            <div className="prose prose-lg text-navy/70 font-light mb-12" data-id="element-501" data-mp="19giiaeoy3x5r">
              <p data-id="element-502" data-mp="19eo038526j5d">
                <strong data-id="element-503" data-mp="1e80gww3hxlnk">Our Philosophy:</strong> We don't chase. We don't
                pressure. We believe in providing exceptional value, curated
                insights, and unparalleled service.
              </p>
              <p className="italic text-gold mt-4" data-id="element-504" data-mp="mhchbohh0oc0">
                "When you're ready, we're ready."
              </p>
            </div>

            <div className="space-y-6" data-id="element-505" data-mp="qifx6aziqkd8">
              <div className="flex items-start" data-id="element-506" data-mp="vgpw8wod6544">
                <MapPin className="text-gold mr-4 mt-1" size={24} data-id="element-507" data-mp="vfxz3hf4bzbq" />
                <div data-id="element-508" data-mp="10hdlbct18bvp">
                  <h4 className="font-serif text-navy text-lg" data-id="element-509" data-mp="10hx2usersy97">Office</h4>
                  <p className="text-navy/60 font-light" data-id="element-510" data-mp="26x7ki9ht51fo">
                    Cabo San Lucas, BCS, Mexico
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-511" data-mp="1m7df7ntvlxkn">
                <Phone className="text-gold mr-4 mt-1" size={24} data-id="element-512" data-mp="1m62c7q898tul" />
                <div data-id="element-513" data-mp="1h8sbvfjbuxrz">
                  <h4 className="font-serif text-navy text-lg" data-id="element-514" data-mp="1h7h6xce5bjza">Phone</h4>
                  <p className="text-navy/60 font-light" data-id="element-515" data-mp="1w62tz7qh71wo">+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-516" data-mp="1r7hw3eyp4ube">
                <Mail className="text-gold mr-4 mt-1" size={24} data-id="element-517" data-mp="1r4lxdof0y1lw" />
                <div data-id="element-518" data-mp="13hdqj21y6khr">
                  <h4 className="font-serif text-navy text-lg" data-id="element-519" data-mp="13ermvdi6gp4t">Email</h4>
                  <p className="text-navy/60 font-light" data-id="element-520" data-mp="yjc90lk66t8e">
                    hello@cabocollection.com
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form Side */}
          <motion.div {...fadeIn} transition={{
          delay: 0.2
        }} className="bg-white p-8 md:p-10 shadow-sm" data-id="element-521" data-mp="18e44nju6z60j">
            {submitted ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-522" data-mp="2ren087d7oaul">
                <Send className="text-gold mb-6" size={48} data-id="element-523" data-mp="2w5d3nf22u3mn" />
                <h3 className="text-2xl font-serif text-navy mb-2" data-id="element-524" data-mp="2w6y0xcfs00o7">
                  Message Received
                </h3>
                <p className="text-navy/70 font-light" data-id="element-525" data-mp="2hem9w1gxcugw">
                  Thank you for reaching out. We will get back to you shortly.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-526" data-mp="3a31lsf4rewo0">
                <div data-id="element-527" data-mp="3f2wgyuvki8ev">
                  <label className="block text-xs font-semibold text-navy uppercase tracking-wider mb-2" data-id="element-528" data-mp="3f3fve1m0eeo5">
                    Name
                  </label>
                  <input type="text" required value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} className="w-full px-4 py-3 bg-sand border border-navy/10 focus:outline-none focus:border-gold font-light" data-id="element-529" data-mp="3559wztzevqo1" />
                </div>
                <div data-id="element-530" data-mp="207oeyo9vo2oa">
                  <label className="block text-xs font-semibold text-navy uppercase tracking-wider mb-2" data-id="element-531" data-mp="2099581p5szgc">
                    Email
                  </label>
                  <input type="email" required value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} className="w-full px-4 py-3 bg-sand border border-navy/10 focus:outline-none focus:border-gold font-light" data-id="element-532" data-mp="2swve9ph5owal" />
                </div>
                <div data-id="element-533" data-mp="17h7hyyzns2vv">
                  <label className="block text-xs font-semibold text-navy uppercase tracking-wider mb-2" data-id="element-534" data-mp="13hfg154rsuzh">
                    How can we help?
                  </label>
                  <textarea required rows={5} value={form.message} onChange={e => setForm({
                ...form,
                message: e.target.value
              })} className="w-full px-4 py-3 bg-sand border border-navy/10 focus:outline-none focus:border-gold font-light resize-none" data-id="element-535" data-mp="3f3h8143qguog"></textarea>
                </div>
                <button type="submit" className="w-full bg-navy text-white py-4 uppercase tracking-wider text-sm font-semibold hover:bg-navy-light transition-colors" data-id="element-536" data-mp="ar2iuc2sjm05">
                  Send Message
                </button>
              </form>}
          </motion.div>
        </div>
      </section>
    </div>;
}